import React from 'react';
import {Form, Input, Checkbox, Button, Alert} from 'antd';
import {mailService} from '../api/mail.api';

const { TextArea } = Input;

const formItemLayout = {
    labelCol: {
      xs: {
        span: 24,
      },
      sm: {
        span: 4,
      },
    },
    wrapperCol: {
      xs: {
        span: 24,
      },
      sm: {
        span: 24,
      },
    },
  };
const tailFormItemLayout = {
    wrapperCol: {
      xs: {
        span: 24,
        offset: 8,
      },
      sm: {
        span: 24,
        offset: 8,
      },
    },
};
class Contact extends React.Component {

    constructor(props)
    {
        super(props);

        this.state = {
            sendingWebContact: false,
            webcontactSent: false,
            webcontactError: false,
        }
    }

    onFinish = (values) => {
        this.setState({sendingWebContact: true})
        mailService.webMessage(values)
            .then(result => {
                this.setState({webcontactError: false, sendingWebContact: false, webcontactSent: true});
            })
            .catch(error => {
                this.setState({webcontactError: true, sendingWebContact: false, ebcontactSent: false});
            })
    };

    render()
    {
        return(
            <section id="contact" className="contact_area section_70" data-scroll-index="7">
                <div className="container">
                    <div className="row">
                    <div className="section-head text-align col-lg-8 offset-lg-2 col-md-10 offset-md-1">
                        <h4>Contacteer Ons</h4>
                    </div>
                    <div className="col-lg-5">
                        <div className="info bg-img mb-md50" data-background="/img/map.png">
                            <div className="item">
                                <div className="cont">
                                <h6>Telefoon : </h6>
                                <p>+32 468 27 10 56</p>
                                </div>
                            </div>
                            <div className="item">
                                <div className="cont">
                                <h6>Adres : </h6>
                                <p>Pastorijstraat 14/1 , 3530 Houthalen-Helchteren</p>
                                </div>
                            </div>
                            <div className="item">
                                <div className="cont">
                                <h6>Email : </h6>
                                <p>info@rentorama.be</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-7">
                    {!this.state.webcontactError && this.state.webcontactSent && <Alert message="We hebben je vraag goed ontvangen en zullen je zo spoedig mogelijk antwoorden." type="success" showIcon />}
                    {this.state.webcontactError && this.state.webcontactSent && <Alert message="Er ging iets fout bij het versturen van de mail, probeer je opnieuw?" type="error" showIcon />}
                    <Form
                    {...formItemLayout}
                    name="register"
                    onFinish={this.onFinish}
                    scrollToFirstError
                    >
                    <Form.Item
                        name="from"
                        label="E-mail"
                        rules={[
                        {
                            type: 'email',
                            message: 'Dit is geen geldige e-mail.',
                        },
                        {
                            required: true,
                            message: 'Vul uw e-mail in.',
                        },
                        ]}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        name="first_name"
                        label="Voornaam"
                        rules={[
                        {
                            required: true,
                            message: 'Vul uw voornaam in.',
                            whitespace: true,
                        },
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        name="last_name"
                        label="Achternaam"
                        rules={[
                        {
                            required: true,
                            message: 'Vul uw achternaam in.',
                            whitespace: true,
                        },
                        ]}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        name="telephone"
                        label="Telefoon"
                        rules={[
                        {
                            required: false,
                            message: 'Vul uw telefoonnummer in.',
                        },
                        ]}
                    >
                        <Input
                        style={{
                            width: '100%',
                        }}
                        />
                    </Form.Item>
                    <Form.Item
                        name="message"
                        label="Bericht"
                        rules={[
                        {
                            required: true,
                            message: 'Gelieve een bericht in te voeren.',
                        },
                        ]}
                    >
                        <TextArea
                            placeholder="Waar kunnen wij u mee van dienst zijn?"
                            autoSize={{ minRows: 4, maxRows: 6 }}
                            style={{
                                width: '100%',
                            }}
                        />
                    </Form.Item>

                    <Form.Item
                        name="agreement"
                        valuePropName="checked"
                        rules={[
                        {
                            validator: (_, value) =>
                            value ? Promise.resolve() : Promise.reject('U dient onze algemene voorwaarden en privacybeleid te accepteren.'),
                        },
                        ]}
                        {...formItemLayout}
                    >
                        <Checkbox>
                            Door gebruik te maken van onze diensten gaat u akkoord met onze <a href="/terms">Algemene Voorwaarden</a> en <a href="/privacy">Privacybeleid</a>. U geeft ons toestemming om uw gegevens te gebruiken louter en alleen voor het uitvoeren van onze diensten.
                        </Checkbox>
                    </Form.Item>
                    <Form.Item {...tailFormItemLayout}>
                        <Button loading={this.state.sendingWebContact} type="primary" htmlType="submit">
                            Verstuur
                        </Button>
                    </Form.Item>
                    </Form>
                    </div>
                    </div>
                </div>
            </section>
        )
    }
}

export default Contact
